module.exports = __webpack_public_path__ + "img/img_delivery_possible.2475b91.png";